import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/unmcontactus/cecUnmContactUs/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/unmcontactus/cecUnmContactUs/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/unmcontactus/cecUnmContactUs/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/unmcontactus/cecUnmContactUs/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/unmcontactus/cecUnmContactUs/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/unmcontactus/cecUnmContactUs/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/unmcontactus/cecUnmContactUs/import',
      method: 'post',
      data: data
    })
  },
  sendEmailForCustomer: function (data) {
    return request({
      url: '/unmcontactus/cecUnmContactUs/sendEmailForCustomer',
      method: 'post',
      data: data
    })
  }
}
